import * as React from 'react';
import { matchPath } from 'react-router-dom';

import { IconSize } from 'shared/entities/components/Icon';
import { urls } from 'shared/entities/domain';
import { HomeIcon } from 'shared/newComponents/icons';
import { useProjectStore, useRouterStore } from 'stores/index';
import { ComponentType } from 'shared/entities/components/Component';

import BreadcrumbItem from '../BreadcrumbItem';
import Arrow from '../Arrow';

import '../Breadcrumbs.modules.scss';

type Props = {
  className?: string;
};

const HomeItem: React.FC<Props> = ({ className }: Props) => {
  const routerStore = useRouterStore();
  const projectStore = useProjectStore();

  const projectId = projectStore.projectId;
  const isActive = !!matchPath(
    routerStore.pathname,
    urls.PROJECT.tabs.ONBOARDING.mask
  );

  return (
    <>
      <BreadcrumbItem
        styleName="breadcrumbs__item"
        className={className}
        isActive={isActive}
        disabled={!projectId}
        action={{
          type: ComponentType.link,
          to: projectId
            ? urls.PROJECT.tabs.ONBOARDING.create({
                projectId
              })
            : urls.SETTINGS.root,
          mask: urls.PROJECT.tabs.ONBOARDING.mask
        }}
      >
        <HomeIcon iconSize={IconSize.XM} />
      </BreadcrumbItem>
      <Arrow styleName="breadcrumbs__item" />
    </>
  );
};

export default HomeItem;
